export var ENominationStatus;
(function (ENominationStatus) {
    ENominationStatus["Opted_In"] = "Opted In";
    ENominationStatus["Opted_Out"] = "Opted Out";
})(ENominationStatus || (ENominationStatus = {}));
